//  ----------      START   IMPORT  BLOCK       ----------
//  Widgets
import Container from 'react-bootstrap/Container';
//  Context
import { useLanguage } from "../../../../API/Context/LanguageContext";
import { useApplicationUI } from '../../../../API/Context/AppUIContext';
//  Config
import {VocabSummary as vocab} from "../../../../ConfigFiles/multilingual/VocabSummary";
import { FRONTEND_ROUTES } from '../../../../ConfigFiles/Routes/frontend_routes';
//  ----------      END   IMPORT  BLOCK       ----------

const DefaulSummary = () => {
    //  Consume context
    const { lan } = useLanguage()
    const { isProfessionalDashboardActive } = useApplicationUI();

    const dashboardContent = {
        //  Content for the Professional Dashboard (isProfessionalDashboardActive === true)
        professional: {
            heading: vocab.ready_to_begin_pro[lan],
            paragraph1: vocab.instructions_to_begin_pro[lan],
            paragraph2_prefix: vocab.need_help[lan],
            paragraph2_link: vocab.here[lan],
            link_path: FRONTEND_ROUTES.professionals_manual, 

        },
        // Content for the Standard Dashboard (isProfessionalDashboardActive === false)
        standard: {
            heading: vocab.ready_to_begin_general[lan],
            paragraph1: vocab.instructions_to_begin_general[lan],
            paragraph2_prefix: vocab.need_help[lan],
            paragraph2_link: vocab.here[lan],
            link_path: FRONTEND_ROUTES.professionals_manual,
        }
    };

    const activeContent = isProfessionalDashboardActive 
    ? dashboardContent.professional 
    : dashboardContent.standard;
    
    return (
        <Container className="mt-5 text-center">
            {/* Heading */}
            <h3>{activeContent.heading}</h3>
            {/* Paragraph 1 */}
            <p className="text-muted">{activeContent.paragraph1}</p>

            {/* Paragraph 2 with Link */}
            <p className="text-muted">
                {activeContent.paragraph2_prefix}
                <a 
                    href={activeContent.link_path}
                    target="_blank" 
                    rel="noopener noreferrer" 
                    className="text-primary hover:text-blue-700 bg-transparent border-none p-0 ml-1 cursor-pointer underline"
                    aria-label="Click here for help"
                >
                    {activeContent.paragraph2_link}
                </a>
            </p>
        </Container>
    );
}

export default DefaulSummary;